import { Component, Input, OnInit } from '@angular/core';
import { ArgyleIncomeStream } from 'src/app/models/Argyle';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { GroupApplicantsService } from 'src/app/services/group-applicants.service';

@Component({
  selector: 'app-bank-account-sync',
  templateUrl: './bank-account-sync.component.html',
  styleUrls: ['./bank-account-sync.component.less']
})
export class BankAccountSyncComponent implements OnInit {
  @Input() stream!: ArgyleIncomeStream;

  expandedStreams: { [id: string]: boolean } = {};
  primaryStreams: any[] = [];
  depositsExpanded = false;
  depositDaysSpan = 60;
  grossMonthlyBreakdown: { month: string; gross: number }[] = [];
  totalGrossDeposits = 0;

  constructor(public modalService: NgbModal, private toast: ToastrService, private auth: AuthService, public appData: ApplicantDataService, public groups: GroupApplicantsService) { }

  ngOnInit(): void {
    if (this.stream?.historicalData?.length) {
      const historical = this.stream.historicalData[0];
      const streams = historical?.income_streams || [];
      this.primaryStreams = streams
        .filter((s: any) => s.status === 'ACTIVE' && s.confidence >= 50)
        .sort((a: any, b: any) => b.projected_net_annual - a.projected_net_annual);

      const txs = historical?.transactions || [];
      const deposits = txs.filter((tx: any) => tx.amount >= 0);
      if (deposits.length >= 2) {
        const dates = deposits.map((tx: any) => new Date(tx.posted_date).getTime());
        const oldest = Math.min(...dates);
        const newest = Math.max(...dates);
        this.depositDaysSpan = Math.round((newest - oldest) / (1000 * 60 * 60 * 24));
      }

      // Build gross monthly breakdown from all deposit transactions
      const monthMap: { [key: string]: number } = {};
      deposits.forEach((tx: any) => {
        const d = new Date(tx.posted_date);
        const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
        monthMap[key] = (monthMap[key] || 0) + tx.amount;
      });
      this.grossMonthlyBreakdown = Object.keys(monthMap)
        .sort()
        .map(k => ({ month: k, gross: monthMap[k] }));
      this.totalGrossDeposits = deposits.reduce((sum: number, tx: any) => sum + tx.amount, 0);
    }
  }

  toggleStream(id: string): void {
    this.expandedStreams[id] = !this.expandedStreams[id];
  }

  getMonthLabel(dateStr: string): string {
    const d = new Date(dateStr);
    return d.toLocaleString('default', { month: 'short', year: 'numeric' });
  }

  getTotalMonthlyNet(incomeStream: any): number {
    return (incomeStream.net_monthly || []).reduce((sum: number, m: any) => sum + m.net, 0);
  }

  getRecentTransactions(incomeStream: any, limit: number = 10): any[] {
    return (incomeStream.transactions || [])
      .sort((a: any, b: any) => new Date(b.posted_date).getTime() - new Date(a.posted_date).getTime())
      .slice(0, limit);
  }

  getConfidenceClass(confidence: number): string {
    if (confidence >= 80) return 'confidence-high';
    if (confidence >= 50) return 'confidence-medium';
    return 'confidence-low';
  }

  getEstimateClass(estimate: string): string {
    if (estimate === 'HIGH') return 'estimate-high';
    if (estimate === 'MODERATE') return 'estimate-medium';
    return 'estimate-low';
  }

  public nonNegativeTransactions(historical: any) {
    const transactions = historical?.transactions || [];
    return transactions
      .filter((tx: any) => tx.amount >= 0)
      .sort((a: any, b: any) => new Date(b.posted_date).getTime() - new Date(a.posted_date).getTime());
  }
}
